import styled from 'styled-components';
import React, { ReactNode } from 'react';

type ClientTruncateProps = {
  children?: ReactNode;
  lines?: number | false;
  trimWhitespace?: boolean;
};

interface TruncateWrapperProps {
  $lines: number;
}

const TruncateWrapper = styled.div<TruncateWrapperProps>`
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ $lines }) => $lines};
  overflow: hidden;
  word-break: break-word;
`;

const ClientTruncate: React.FC<ClientTruncateProps> = ({ children, lines = 1 }) => {
  if (!lines) {
    return <>{children}</>;
  }

  return <TruncateWrapper $lines={lines}>{children}</TruncateWrapper>;
};

export default ClientTruncate;
